import { CompanyAuth } from "../../../../entities/login/CompanyAuth";

export class ScheduledTaskListRequest {
  page: number = 0;
  pagesize: number = 50;
  mainfav?: number;
  status?: number;
  personId?: string;
  groupdId?: string;
  filter: string = "";
  sortcolumn: string = "dueDate";
  descending: number = 0;
  text?: string;
  constructor(
    userId: string | null,
    public additionaldefinitions: CompanyAuth.AdditionalDefinition[],
    groupId?: string
  ) {
    if (userId) {
      this.personId = userId;
    }
    this.groupdId = groupId;
  }
}
